//
//
//
//
//
// import { menuDetail } from '@/layout/components'
export default {
  name: 'HeadBar' // components: {
  //     menuDetail
  // },

};